/*Check route to access to scorecard*/

import React from 'react';
import Loadable from 'react-loadable';
//import SelectScorecardModal from '../../components/SelectScorecardModal/SelectScorecardModal';
import ScorecardMasterSelection from '../../views/BCMUser/ScorecardMasterSelection/ScorecardMasterSelection';
import queryString from 'query-string';
import AxiosInstance from '../../components/AxiosInstance/AxiosInstance';

function Loading() {
  return <div>Loading...</div>;
}

export default function BCMUserLoad(opts) {

  return Loadable(Object.assign({
    loading: Loading,
    //      timeout: 10000,

    render(loaded, props) {

      let Component = loaded.default;

      //let params = queryString.parse(props.location.search);

      //let prev = sessionStorage.getItem("sub_Menu");

      //if (params.tbBCMmDepartmentID !== undefined) {

      //  AxiosInstance({
      //    method: 'post',
      //    url: 'tbGEN_m_Level/usp_tbGEN_m_Level_SelectByDeptLevelWithAccessRights_V12',
      //    data: {
      //      dcKey: 0
      //    }
      //  })
      //    .then(response => {
      //      if (response != undefined && response.data != undefined) {

      //        var filter = [];
      //        filter.push(parseFloat(params.tbBCMmDepartmentID));

      //        let selectFilter = response.data;
      //        selectFilter = selectFilter.filter(item => {
      //          return filter.indexOf(item.tbBCMmDepartmentID) > -1;
      //        })

      //        sessionStorage.setItem('NewQRadar_tbBCMmDepartmentID', params.tbBCMmDepartmentID);
      //        sessionStorage.setItem('NewQRadar_scoreCard', selectFilter[0].name);
      //        sessionStorage.setItem('NewQRadar_tbWFLtBCMTransactionID', -1);
      //        sessionStorage.setItem('NewQRadar_readOnly', selectFilter[0].readOnly);
      //        sessionStorage.setItem('NewQRadar_writeOnly', selectFilter[0].writeOnly);
      //        sessionStorage.setItem('NewQRadar_deleteOnly', selectFilter[0].deleteOnly);
      //        sessionStorage.setItem('NewQRadar_reportOnly', selectFilter[0].reportOnly);
      //        sessionStorage.setItem("sub_Menu", "BCM User");
      //        if (prev == "BCM Dashboard") {
      //          window.location.reload();
      //        }

      //      }
      //    })
      //    .catch(function (error) {
      //      // console.log(error);
      //    });
      //}

      if (sessionStorage.getItem('NewQRadar_tbBCMmDepartmentID') == null) {
        return <ScorecardMasterSelection />;     /*check if session not available then will prompt user select scorecard */
      }
      else {
        return <Component {...props} />; /*if session available then can continue*/
      }
    },
  }, opts));
};
